/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */

import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '../ui/button';
import { PricingModal } from './PricingModal';
import { useAuth } from '../../hooks/useAuth';

interface UpgradeButtonProps {
  variant?: 'default' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  showIcon?: boolean;
  children?: React.ReactNode;
}

export const UpgradeButton = ({
  variant = 'default',
  size = 'default',
  className = '',
  showIcon = true,
  children,
}: UpgradeButtonProps) => {
  const [showPricing, setShowPricing] = useState(false);
  const { isFree, isSignedIn } = useAuth();

  // Don't show upgrade button for pro/premium users
  if (!isFree) return null;

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={`${className} ${variant === 'default' ? 'bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600' : ''}`}
        onClick={() => setShowPricing(true)}
      >
        {showIcon && <Sparkles className="h-4 w-4 mr-2" />}
        {children || 'Upgrade to Pro'}
      </Button>

      <PricingModal open={showPricing} onOpenChange={setShowPricing} />
    </>
  );
};
